import s from './ItemForm.module.css'
import {
    useEffect,
    useCallback,
    useState,
    forwardRef,
    ChangeEventHandler,
    FormEventHandler,
} from 'react'
import { GroceryItem } from '../types'
import ColorChooser from './ColorChooser'
import { COLORS } from '../constants'

type FormItemProps = {
    item?: GroceryItem
    onSubmitItem: (itemName: string, color: string) => void
    onTyping: (itemName: string) => void
}

const ItemForm = forwardRef<HTMLInputElement, FormItemProps>(
    ({ item, onSubmitItem, onTyping }, textInputRef) => {
        const [itemName, setItemName] = useState('')
        const [color, setColor] = useState(COLORS[0])

        const onSubmitItemForm: FormEventHandler<HTMLFormElement> = useCallback(
            (e) => {
                e.preventDefault()
                onSubmitItem(itemName, color)
                setItemName('')
                onTyping('')
            },
            [onSubmitItem, itemName, color, onTyping]
        )

        const onClearClick = useCallback(() => {
            setItemName('')
            onTyping('')
        }, [onTyping])

        const onChange: ChangeEventHandler<HTMLInputElement> = useCallback(
            (e) => {
                const v = e.target.value
                setItemName(v)
                onTyping(v)
            },
            [onTyping]
        )

        useEffect(() => {
            if (item) {
                setItemName(item.name)
                setColor(item.color)
            }
        }, [item])

        const disabled = itemName.length === 0

        return (
            <form className={s.ItemForm} onSubmit={onSubmitItemForm}>
                <input
                    ref={textInputRef}
                    className={s.ItemFormInput}
                    type="text"
                    placeholder="item"
                    required
                    autoFocus
                    minLength={2}
                    maxLength={100}
                    value={itemName ?? ''}
                    onChange={onChange}
                ></input>
                <ColorChooser color={color} onChange={setColor} />
                <button className={s.ItemFormButton} disabled={disabled}>
                    ✅
                </button>
                <button
                    className={s.ItemFormButton}
                    onClick={onClearClick}
                    disabled={disabled}
                    title="clear"
                >
                    ❌
                </button>
            </form>
        )
    }
)

export default ItemForm
